import wssEventNotifier from '../wss/WssEventNotifier';
import CoreBase from './CoreBase';

export default class WssEventHandlerBase extends CoreBase {
    _name = 'WssEventHandlerBase';

    _wssEventNotifier = wssEventNotifier;

    bootup() {
        //
    }

    cleanup() {
        //
    }
}
